import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import type { PlacePhotoPayload } from '$/requests/PlacePhotoRequest.ts';
import type { PlacePhotoResult } from '$/dto/PlacePhotoResult.dto.ts';
import supabaseClient from '@/api/supabaseClient.ts';

const requestPlacePhoto = (payload: PlacePhotoPayload): Promise<PlacePhotoResult> =>
  invokeGetPlacePhoto(supabaseClient, payload);

export default requestPlacePhoto;

async function invokeGetPlacePhoto(client: SupabaseClient, payload: PlacePhotoPayload): Promise<PlacePhotoResult> {
  const { data, error } = await client.functions.invoke<PlacePhotoResult>('get_place_photo', { body: payload });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse = (await error.context.json()) as { error?: string; errors?: string[] };
    throw new Error(errorResponse.errors?.join(', ') ?? errorResponse.error ?? 'Failed to load the photo');
  }

  if (error) {
    throw new Error(error.message);
  }

  if (!data?.photo_uri) {
    throw new Error('No photo returned');
  }

  return data;
}
